export default __webpack_public_path__ + "static/media/lime.41c6f0fe.png";